import { render, staticRenderFns } from "./CurrentExamInfo.vue?vue&type=template&id=2f001ede&scoped=true&"
import script from "./CurrentExamInfo.vue?vue&type=script&lang=js&"
export * from "./CurrentExamInfo.vue?vue&type=script&lang=js&"
import style0 from "./CurrentExamInfo.vue?vue&type=style&index=0&id=2f001ede&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f001ede",
  null
  
)

export default component.exports